export default "__VITE_ASSET__DmEg1axK__"